import { IUserRoles} from '../interfaces'

export enum RoleNameEnum {
  Admin = 'Admin',
  EvaluationsandCredits = 'EvaluationsandCredits',
  Financial = 'Financial',
  User = 'User',
  Management = 'Management',
  Official = 'Official',
  LegalAdmin = 'LegalAdmin',
  InvestmentUnit = 'InvestmentUnit',
  Warranty = 'Warranty',
  Board = 'Board',
}

export const isValidRole = (roleList: IUserRoles[], roleName: RoleNameEnum) => {
  return roleList.some((role) => role.role.normalizedName === roleName)
}
